import { render } from "./RegistrationCompanyEstablishmentListComponent.vue?vue&type=template&id=172b9823&scoped=true"
import script from "./RegistrationCompanyEstablishmentListComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompanyEstablishmentListComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompanyEstablishmentListComponent.vue?vue&type=style&index=0&id=172b9823&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172b9823"]])

export default __exports__